<template>
  <el-dialog
    :title="type === 'edit'?'编辑':'新增'"
    :visible.sync="dialog"
    :width="getIsMobile?'100%':'70%'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form ref="formRef" :model="form" label-width="100px" :label-position="getIsMobile?'top':'right'" :rules="rules" class="custom-form">
      <el-form-item label="公司名称" prop="company">
        <el-input v-model="form.company" placeholder="请输入公司名称"></el-input>
      </el-form-item>
      <el-form-item label="公司类别" prop="cid">
<!--        取的是客户分类-->
        <el-radio-group v-model="form.cid">
          <el-radio :label="item.cid" v-for="item in companyType" :key="item.cid">{{item.classname}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="公司地址" prop="address">
        <el-input v-model="form.address" placeholder="请输入公司地址"></el-input>
      </el-form-item>
      <el-form-item label="收货地址" prop="raddress">
         <Contacts ref="contactFormRef" :data="formData.child_lxr" :listrow="formData.listrow"/>
       </el-form-item>
    </el-form>
    <Remarks ref="remarkFormRef" :data="formData.child_content"/>
    <el-divider v-if="type === 'edit'">开票资料</el-divider>
    <InvoiceInfo ref="invoiceInfoFormRef" :data="formData.listrow" v-if="type === 'edit'"/>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleReset">重 置</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, ref, watch } from '@vue/composition-api'
import Contacts from './contacts.vue';
import useRootSetting from '@/hooks/useRootSetting';
import request from '@/utils/request';
import Remarks from './remarks.vue'
import InvoiceInfo from './invoiceInfo.vue'

export default defineComponent({
  components: {Contacts,Remarks,InvoiceInfo},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => {

      }
    }
  },
  setup(props,{emit}) {
    const {getIsMobile} = useRootSetting()
    const formRef = ref(null)
    const invoiceInfoFormRef = ref(null)
    const rules = {
      company: [
        { required: true, message: '公司名称不能为空', trigger: 'blur' }
      ],
      // classname: [
      //   { required: true, message: '公司类别不能为空', trigger: 'change' }
      // ],
      // address: [
      //   { required: true, message: '公司地址不能为空', trigger: 'blur' }
      // ],
      // raddress: [{ required: true, message: '请输入收货地址', trigger: 'blur' }],
      // content: [{ required: true, message: '请输入备注', trigger: 'blur' }],
    }

    const radio = ref(1)
    const defaultForm = () => ({
      company:'',
      cid: 1,
      address:'',
    })
    const form = reactive(defaultForm())
    const contactFormRef = ref(null)
    const remarkFormRef = ref(null)

    watch(()=> props.formData, (val)=> {
      if(props.type === 'add') return;
      if(val){
        if(val.listrow.length>0){
          form.company = val.listrow[0].company
          form.address = val.listrow[0].address
          form.cid = val.listrow[0].cid
        }
      }
    })

    const handleReset = () => {
      Object.assign(form,defaultForm())
      contactFormRef.value.raddress = ''
      contactFormRef.value.clearTable()
      if(invoiceInfoFormRef.value)invoiceInfoFormRef.value.handleReset()
      remarkFormRef.value.clearTable()
    }

    const handleSubmit = () => {
        formRef.value.validate(valid => {
        if (valid) {
          const formCopy = JSON.parse(JSON.stringify(form))
          emit('submit', formCopy,contactFormRef.value.contacts,contactFormRef.value.raddress,remarkFormRef.value.form.child_content,props.type === 'edit' && invoiceInfoFormRef.value.form)
        }
      })
    }



    const handleClose = () => {
      emit('close')
      handleReset()
    }

    const companyType = ref([])
    const getCompanyType = () => {
      request({
        url: 'company_type.yy ',
        method: 'post',
      }).then(res => {
          if(res.code == 200){
            companyType.value = res.data
          }
      })
    }

    watch(()=>props.dialog,(dialog)=>{
      if(dialog) getCompanyType()
    })

    return {
      invoiceInfoFormRef,
      remarkFormRef,
      companyType,
      contactFormRef,
      formRef,
      form,
      rules,
      radio,
      getIsMobile,
      handleReset,
      handleSubmit,
      handleClose
    }
  }
})
</script>
